import { render, staticRenderFns } from "./OriginalOrderListPartial.vue?vue&type=template&id=4bfcd808&scoped=true&"
import script from "./OriginalOrderListPartial.vue?vue&type=script&lang=js&"
export * from "./OriginalOrderListPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfcd808",
  null
  
)

export default component.exports